import { AnimatePresence } from 'framer-motion';
import styled from 'styled-components';

import { Stack } from '@components/stack';
import { pxToRem } from '@utils/converters';

import { Toast } from './toast';
import { useToastStore } from './use-toaster';

export const Toaster = () => {
  const toasts = useToastStore((state) => state.toasts);

  return (
    <Container>
      <Stack space={3}>
        <AnimatePresence>
          {toasts.map((toast, index) => (
            <Toast key={toast.id} toast={toast} index={index} />
          ))}
        </AnimatePresence>
      </Stack>
    </Container>
  );
};

const Container = styled.ul({
  width: pxToRem(418),
  position: 'fixed',
  zIndex: 99999,
  bottom: '2rem',
  left: `calc(50% - ${pxToRem(209)})`,
});
